// routes
// import { PATH_DASHBOARD } from './routes/paths';

// API
/* ======================================================================================= */

import { DarkTheme } from '../theme/schemes/dark-theme';
import { LightTheme } from '../theme/schemes/light-theme';

export const HOST_API = process.env.REACT_APP_HOST_API_KEY || '';

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const COGNITO_API = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};

export const MAPBOX_API = process.env.REACT_APP_MAPBOX;


// ROOT PATH AFTER LOGIN SUCCESSFUL
// export const PATH_AFTER_LOGIN = PATH_DASHBOARD.general.app; // as '/dashboard/app'

// LAYOUT
/* ======================================================================================= */

export const HEADER = {
  MOBILE_HEIGHT: 72,
  DESKTOP_HEIGHT: 96,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  WIDTH: 0,
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
  //
  NAVIGATION_WIDTH: 0,
};

export const FOOTER = {
  FOOTER_MOBILE: 0,
  FOOTER_DESKTOP: 0,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 24,
};

export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const DESKTOP_WIDTH = 1200;

// SETTINGS
// Please remove `localStorage` when you set settings.
// ----------------------------------------------------------------------

export const THEMES = {
  DarkTheme: 'DarkTheme',
  LightTheme: 'LightTheme',
}

export const MODES = {
  Dark: 'dark',
  Light: 'light',
}

export const defaultSettings = {
  themeMode: THEMES.LightTheme,
  themeDirection: 'ltr',
  themeColorPresets: 'default',
  themeLayout: 'horizontal',
  themeStretch: false,
};
